import { mainStore } from "../stores/MainStore";

export const useReleaseNotesStore = () => {
  return mainStore.releaseNotesStore;
};
